module.exports = __webpack_public_path__ + "img/sqc.3adc3ca7.png";